import axiosClient from "@api/axios";
import { get } from "lodash";
import { useMutation } from "react-query";

const getChatConversations = ({ convType, page = 1, recordPerPage = 10 }) => {
  return axiosClient.get(`/v1/conv/listing`, {
      params: {
        page: page,
        recordPerPage: recordPerPage,
        convType: convType
      }
    }
  );
}

const fetchChatMessages = ({ conversationId, page = 1, recordPerPage = 10}) => {
  return axiosClient.get(`/v1/conv/${conversationId}/msg`, {
    params: {
      page: page,
      recordPerPage: recordPerPage
    }
  })
}

const getChatMatch = async (page = 1,
  matchCode = '',
  recordPerPage = 10) => {
  try {
    const res = await axiosClient.get(`v1/conv/${matchCode}/msg?page=${page}&recordPerPage=${recordPerPage}`);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

const usePostMessage = () => {
  return useMutation(createMessage);
};

const postMessage = ({ conversationId, content }) => {
  return axiosClient.post(`/v1/conv/${conversationId}/msg`, {
    content: content
  });
}
const createMessage = async (payload) => {
  const { conversationId, ...body } = payload;
  const response = await axiosClient.post(`/v1/conv/${conversationId}/msg`, body);
  return response;
};

export {
  getChatConversations,
  fetchChatMessages,
  postMessage,
  getChatMatch,
  usePostMessage,
}